var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName)},[(_vm.reload)?_c(_vm.option.is,_vm._b({ref:_vm.id,tag:"component",style:(_vm.styleChartName)},'component',_vm.config,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }